module.exports = __webpack_public_path__ + "static/media/ic-cashback.6a6c0922.svg";